<template>

    <div class="container">
        <div>
            <h3>Login</h3>
        </div>

        <feedback :error="login.error"/>

        <div class="form-group">
            <label>Email</label>
            <input class="form-control" type="email"
                   name="email"
                   v-bind:class="{'is-invalid': login.fieldErrors.email}"
                   v-bind:value="login.email"
                   @input="onChange"/>
            <div class="invalid-feedback" v-if="login.fieldErrors.email">
                {{login.fieldErrors.email}}
            </div>
        </div>
        <div class="form-group">
            <label>Password</label>
            <input class="form-control" type="password"
                   v-bind:value="login.password"
                   v-bind:class="{'is-invalid': login.fieldErrors.password}"
                   @input="onChange" name="password">
            <div class="invalid-feedback" v-if="login.fieldErrors.password">
                {{login.fieldErrors.password}}
            </div>
        </div>
        <div class="form-group">
            <button type="button" class="btn btn-primary mr-2"
                    v-on:click="submit">Submit</button>
            <router-link to="/register" class="ml-1">Register</router-link>
            <span class="ml-1">|</span>
            <router-link to="/reset-password" class="ml-1">Forgot password</router-link>
        </div>
        <hr/>
        <div class="form-group">
            <a href="/api/users/google-login" ><font-awesome-icon :icon="['fab', 'google']" class="red"></font-awesome-icon> <span class="ml-2">log in using google account</span></a>
        </div>

    </div>
</template>

<script>

    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import {mapState, mapActions} from "vuex";
    import {LOGIN, LOGIN_ON_CHANGE, LOGIN_ON_VALIDATE} from "../../store/login";
    import Feedback from "../commons/feedback";

    export default {
        name: "login",
        components: {
            Feedback,
            FontAwesomeIcon
        },
        computed: mapState({
            login: state => state.login,
        }),
        methods: {
            ...mapActions({
                submitLogin: LOGIN,
                onLoginChange: LOGIN_ON_CHANGE,
                validate: LOGIN_ON_VALIDATE
            }),
            onChange(event) {
                this.onLoginChange({name: event.target.name, value: event.target.value});
            },
            submit() {
                this.validate();
                if(this.login.error){
                    return;
                }

                this.submitLogin(() => {
                    if(this.login.error){
                        return;
                    }

                    this.$router.replace(this.$route.query.redirect || '/')
                });
            }
        }
    }
</script>

<style scoped>

</style>
